import calling_coderegular from './font-data/calling_coderegular.txt';
import pelagiadregular from './font-data/pelagiadregular.txt';
import almendra_bold from './font-data/almendrabold.txt';
import benne_regular from './font-data/benneregular.txt';
import cherryswash_regular from './font-data/cherry_swashregular.txt';
import fantasquesansmono_regular from './font-data/fantasque_sans_monoregular.txt';
import fingerpaint_regular from './font-data/finger_paintregular.txt';
import ibmplexserif_text from './font-data/ibm_plex_seriftext.txt';

const fontArray = [
    { data: calling_coderegular, name: "calling_coderegular" },
    { data: pelagiadregular, name: "pelagiadregular" },
    { data: almendra_bold, name: "Almendra" },
    { data: benne_regular, name: "Benne Text" },
    { data: cherryswash_regular, name: "Cherry Swash" },
    { data: fantasquesansmono_regular, name: "Fantasque Sans Mono" },
    { data: fingerpaint_regular, name: "Finger Paint" },
    { data: ibmplexserif_text, name: "IBM Plex Serif" }
];

export function fontFetcher(fontIndex, setFontFace, setFontName) {
    async function fetchFont(txtFile) {
        let response = await fetch(txtFile);
        if (!response.ok) {
            throw new Error('Invalid File Input')
        }
        let data = await response.text();
        return data;
    }
    fetchFont(fontArray[fontIndex].data).then(response => { setFontFace(response); setFontName(fontArray[fontIndex].name) })
    .catch(error => console.log("FONT TXT LOAD ERROR" + error));
}

export function fontList() {
    return fontArray.map(item => item.name);
}